import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '@babel/types';

const TextArea = ({ name, rows, onChange, ...restProps }) => {
    return (
        <textarea
            className="form-control"
            name={name}
            rows={rows}
            onChange={onChange}
            {...restProps}
        />
    );
};

TextArea.propTypes = {
    // To refrence the TextArea in the form
    name: PropTypes.string,

    // Specifies the visible number of lines in a text area
    rows: PropTypes.number,

    // To invoke a function on change of the value of TextArea
    onChange: PropTypes.func,
};

TextArea.defaultProps = {
    name: null,
    rows: 4,
    onChange: noop,
};

export default TextArea;
